import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import '../styles/navigation.css';
import { useAuth } from '../contexts/AuthContext';
import { IframeLink as Link } from './IframeLink';
import { useAtlasStore } from '../store/atlasStore';

const LogoIcon = () => (
  <img alt="logo" width="40px" src="data:image/png;base64,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">
  </img>
);

// Navigation icon SVG placeholders
const SearchIcon = () => (
  <svg focusable="false" aria-hidden="true" viewBox="0 0 21 20" font-size="default"><g id="search"><path id="Icon" fill="none" d="M18.0005 17.5L14.3755 13.875M16.3338 9.16667C16.3338 12.8486 13.3491 15.8333 9.66715 15.8333C5.98526 15.8333 3.00049 12.8486 3.00049 9.16667C3.00049 5.48477 5.98526 2.5 9.66715 2.5C13.3491 2.5 16.3338 5.48477 16.3338 9.16667Z" stroke="currentColor" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"></path></g></svg>
);

const ExpandIcon = () => (
  <svg focusable="false" aria-hidden="true" viewBox="0 0 24 24" width="24" height="24">
    <path d="M8.59 16.59L13.17 12L8.59 7.41L10 6l6 6l-6 6l-1.41-1.41z" fill="currentColor" />
  </svg>
);

const CollapseIcon = () => (
  <svg focusable="false" aria-hidden="true" viewBox="0 0 24 24" width="24" height="24">
    <path d="M15.41 16.59L10.83 12l4.58-4.59L14 6l-6 6l6 6l1.41-1.41z" fill="currentColor" />
  </svg>
);

// App icons

const TrendsIcon = () => (
  <svg width="800px" height="800px" viewBox="0 0 128 128" aria-hidden="true" preserveAspectRatio="xMidYMid meet"><radialGradient id="IconifyId17ecdb2904d178eab8626" cx="68.884" cy="124.296" r="70.587" gradientTransform="matrix(-1 -.00434 -.00713 1.6408 131.986 -79.345)" gradientUnits="userSpaceOnUse"><stop offset=".314" stop-color="#ff9800"></stop><stop offset=".662" stop-color="#ff6d00"></stop><stop offset=".972" stop-color="#f44336"></stop></radialGradient><path d="M35.56 40.73c-.57 6.08-.97 16.84 2.62 21.42c0 0-1.69-11.82 13.46-26.65c6.1-5.97 7.51-14.09 5.38-20.18c-1.21-3.45-3.42-6.3-5.34-8.29c-1.12-1.17-.26-3.1 1.37-3.03c9.86.44 25.84 3.18 32.63 20.22c2.98 7.48 3.2 15.21 1.78 23.07c-.9 5.02-4.1 16.18 3.2 17.55c5.21.98 7.73-3.16 8.86-6.14c.47-1.24 2.1-1.55 2.98-.56c8.8 10.01 9.55 21.8 7.73 31.95c-3.52 19.62-23.39 33.9-43.13 33.9c-24.66 0-44.29-14.11-49.38-39.65c-2.05-10.31-1.01-30.71 14.89-45.11c1.18-1.08 3.11-.12 2.95 1.5z" fill="url(#IconifyId17ecdb2904d178eab8626)"></path><radialGradient id="IconifyId17ecdb2904d178eab8627" cx="64.921" cy="54.062" r="73.86" gradientTransform="matrix(-.0101 .9999 .7525 .0076 26.154 -11.267)" gradientUnits="userSpaceOnUse"><stop offset=".214" stop-color="#fff176"></stop><stop offset=".328" stop-color="#fff27d"></stop><stop offset=".487" stop-color="#fff48f"></stop><stop offset=".672" stop-color="#fff7ad"></stop><stop offset=".793" stop-color="#fff9c4"></stop><stop offset=".822" stop-color="#fff8bd" stop-opacity=".804"></stop><stop offset=".863" stop-color="#fff6ab" stop-opacity=".529"></stop><stop offset=".91" stop-color="#fff38d" stop-opacity=".209"></stop><stop offset=".941" stop-color="#fff176" stop-opacity="0"></stop></radialGradient><path d="M76.11 77.42c-9.09-11.7-5.02-25.05-2.79-30.37c.3-.7-.5-1.36-1.13-.93c-3.91 2.66-11.92 8.92-15.65 17.73c-5.05 11.91-4.69 17.74-1.7 24.86c1.8 4.29-.29 5.2-1.34 5.36c-1.02.16-1.96-.52-2.71-1.23a16.09 16.09 0 0 1-4.44-7.6c-.16-.62-.97-.79-1.34-.28c-2.8 3.87-4.25 10.08-4.32 14.47C40.47 113 51.68 124 65.24 124c17.09 0 29.54-18.9 19.72-34.7c-2.85-4.6-5.53-7.61-8.85-11.88z" fill="url(#IconifyId17ecdb2904d178eab8627)"></path></svg>
);

const ConsumerTrendIcon = () => (
  <svg viewBox="0 0 24 24" width="20" height="20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="8" cy="5.5" r="2" stroke="currentColor" strokeWidth="1.5"/>
    <circle cx="16" cy="5.5" r="2" stroke="currentColor" strokeWidth="1.5"/>
    <path d="M5 13.5c0-1.7 1.3-3 3-3s3 1.3 3 3M13 13.5c0-1.7 1.3-3 3-3s3 1.3 3 3" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
    <path d="M3 21l4-3 4 2 5-4 5 2" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

const InnovationIcon = () => (
  <svg width="32px" height="32px" viewBox="0 0 40.96 40.96" ><path d="M3.413 18.773a17.067 17.067 0 1 0 34.133 0 17.067 17.067 0 1 0 -34.133 0" fill="#FFF59D" /><path d="M31.573 18.773c0 -6.571 -5.632 -11.776 -12.373 -11.008 -5.12 0.597 -9.216 4.693 -9.728 9.813 -0.427 3.925 1.195 7.424 3.925 9.643C14.592 28.245 15.36 29.696 15.36 31.317v0.256h10.24V31.488c0 -1.536 0.683 -3.072 1.877 -4.096 2.475 -2.048 4.096 -5.12 4.096 -8.619" fill="#FBC02D" /><path d="m26.112 17.237 -2.56 -1.707c-0.256 -0.171 -0.683 -0.171 -0.939 0L20.48 16.896l-2.048 -1.365c-0.256 -0.171 -0.683 -0.171 -0.939 0l-2.56 1.707c-0.171 0.171 -0.341 0.341 -0.341 0.597s0 0.512 0.171 0.683L18.005 22.528v9.045H19.712V22.187c0 -0.171 -0.085 -0.341 -0.171 -0.512l-2.816 -3.499 1.28 -0.853 2.048 1.365c0.256 0.171 0.683 0.171 0.939 0l2.048 -1.365 1.28 0.853 -2.816 3.499c-0.085 0.171 -0.171 0.341 -0.171 0.512v9.387H23.04V22.528l3.243 -4.011c0.171 -0.171 0.256 -0.427 0.171 -0.683s-0.171 -0.512 -0.341 -0.597" fill="#FFF59D" /><path d="M17.92 37.547a2.56 2.56 0 1 0 5.12 0 2.56 2.56 0 1 0 -5.12 0" fill="#5C6BC0" /><path d="M22.187 38.4h-3.413C16.896 38.4 15.36 36.864 15.36 34.987V30.72h10.24v4.267C25.6 36.864 24.064 38.4 22.187 38.4" fill="#9FA8DA" /><path d="M25.6 34.987 15.701 36.352c0.256 0.597 0.768 1.195 1.365 1.536L25.088 36.779q0.512 -0.768 0.512 -1.792M15.36 33.024v1.707L25.6 33.28v-1.707z" fill="#5C6BC0" /></svg>
);

const NovelIngredientIcon = () => (
  <svg viewBox="0 0 24 24" width="20" height="20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M12 22V12" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
    <path d="M12 12c0-5 5-8 9-9-1 4-4 9-9 9z" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round"/>
    <path d="M12 16c0-4-4-6.5-7-7 .5 3 3 7 7 7z" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round"/>
  </svg>
);

const DiscussIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={800}
    height={800}
    fill="none"
    viewBox="0 0 32 32"
  >
    <path
      fill="#FFA000"
      d="M27 8h-.41L24.9 4.56a1 1 0 0 0-1.42-.415 1 1 0 0 0-.37.395L21.33 8H5a3.07 3.07 0 0 0-3 3.12v13.76A3.07 3.07 0 0 0 5 28h22a3.07 3.07 0 0 0 3-3.12V11.12A3.07 3.07 0 0 0 27 8"
    />
    <path
      fill="#1A237E"
      d="M23.76 18.89a3 3 0 1 0-3.46-1.6 10 10 0 0 0-2.09-.29 3 3 0 1 0-4.42 0 10 10 0 0 0-2.09.27A3 3 0 0 0 12 16a3 3 0 1 0-3.76 2.89A5.28 5.28 0 0 0 6 23a1 1 0 0 0 2 0c0-2.17 2.84-4 6.2-4h3.6c3.36 0 6.2 1.83 6.2 4a1 1 0 0 0 2 0 5.28 5.28 0 0 0-2.24-4.11M23 15a1 1 0 1 1 0 2 1 1 0 0 1 0-2M9 15a1 1 0 1 1 0 2 1 1 0 0 1 0-2m7-1a1 1 0 1 1 0 2 1 1 0 0 1 0-2"
    />
    <path
      fill="#FFB300"
      d="M5 8a3.07 3.07 0 0 0-3 3.12v13.76A3.07 3.07 0 0 0 5 28h11V8z"
    />
    <path
      fill="#303F9F"
      d="M15 15a1 1 0 0 1 1-1v-2a3 3 0 0 0-2.21 5 10 10 0 0 0-2.09.27A3 3 0 0 0 12 16a3 3 0 1 0-3.76 2.89A5.28 5.28 0 0 0 6 23a1 1 0 1 0 2 0c0-2.17 2.84-4 6.2-4H16v-3a1 1 0 0 1-1-1m-6 2a1 1 0 1 1 0-2 1 1 0 0 1 0 2"
    />
  </svg>
);

const CompetitorIcon = () => (
  <svg viewBox="0 0 24 24" width="20" height="20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round"/>
  </svg>
);

const StrategicTopicIcon = () => (
  <svg viewBox="0 0 24 24" width="20" height="20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="1.5"/>
    <polygon points="16.24 7.76 14.12 14.12 7.76 16.24 9.88 9.88" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round"/>
  </svg>
);

const RadarIcon = () => (
  <svg viewBox="0 0 24 24" width="20" height="20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="1.5"/>
    <circle cx="12" cy="12" r="6" stroke="currentColor" strokeWidth="1.5" opacity="0.6"/>
    <circle cx="12" cy="12" r="2" stroke="currentColor" strokeWidth="1.5" opacity="0.4"/>
    <line x1="12" y1="2" x2="12" y2="12" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
  </svg>
);

type NavigationItem = {
  path: string;
  icon: React.ReactElement;
  label: string;
  hint: string;
};

export type NavContext = {
  section: 'main' | 'agent' | 'app';
  path: string;
  hint?: string;
  label?: string;
};

type LocationState = {
  hint?: string;
  label?: string;
  dimensionFqn?: string;
  navContext?: NavContext;
};

// Legacy per-dimension items kept for nav context resolution in UpdatesView/viewer
export const agentNavigationItems: NavigationItem[] = [
  {
    path: '/updates',
    icon: <TrendsIcon />,
    label: 'Market Trends',
    hint: 'prism_dimension@market_trend'
  },
  {
    path: '/updates',
    icon: <TrendsIcon />,
    label: 'Market Trends',
    hint: 'prism_dimension@market_trend_finance'
  },
  {
    path: '/updates',
    icon: <NovelIngredientIcon />,
    label: 'Novel Ingredients',
    hint: 'prism_dimension@novel_ingredient'
  },
  {
    path: '/updates',
    icon: <ConsumerTrendIcon />,
    label: 'Consumer Trends',
    hint: 'prism_dimension@consumer_trend'
  },
  {
    path: '/updates',
    icon: <DiscussIcon />,
    label: 'Consumer Insights',
    hint: 'prism_dimension@consumer_insight'
  },
  {
    path: '/updates',
    icon: <CompetitorIcon />,
    label: 'Competitors',
    hint: 'prism_dimension@competitor'
  },
  {
    path: '/updates',
    icon: <StrategicTopicIcon />,
    label: 'Strategic Topics',
    hint: 'prism_dimension@strategic_topic'
  }
];

// Single Radar nav entry replaces individual dimension items in the sidebar
const radarNavigationItem: NavigationItem = {
  path: '/radar',
  icon: <RadarIcon />,
  label: 'Radar',
  hint: 'radar'
};

const appsNavigationItems = [
  {
    path: '/spark',
    icon: <InnovationIcon />,
    label: 'Innovation Studio',
    hint: 'innovation'
  },
  {
    path: '/spark/search',
    icon: <SearchIcon />,
    label: 'Search Innovation',
    hint: 'innovation_search'
  }
];

export const Navigation: React.FC = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  const location = useLocation();
  const locationState = (location.state as LocationState) || {};
  const navContext = locationState.navContext;
  const [isExpanded, setIsExpanded] = React.useState(false);
  const sparkCreativeTypes = useAtlasStore((state) => state.sparkCreativeTypes);
  const fetchSparkCreativeTypes = useAtlasStore((state) => state.fetchSparkCreativeTypes);
  const isLoadingSparkCreativeTypes = useAtlasStore((state) => state.isLoadingSpark.creativeTypes);
  const hasRequestedSparkCreativeTypesRef = React.useRef(false);

  React.useEffect(() => {
    if (sparkCreativeTypes.length > 0) {
      hasRequestedSparkCreativeTypesRef.current = false;
      return;
    }
    if (!hasRequestedSparkCreativeTypesRef.current && !isLoadingSparkCreativeTypes) {
      hasRequestedSparkCreativeTypesRef.current = true;
      fetchSparkCreativeTypes().catch(() => {/* non-fatal */});
    }
  }, [sparkCreativeTypes.length, isLoadingSparkCreativeTypes, fetchSparkCreativeTypes]);

  const hasEnabledLibraryTypes = React.useMemo(
    () => sparkCreativeTypes.some((creativeType) => !!creativeType.library),
    [sparkCreativeTypes],
  );

  const visibleAppNavigationItems = React.useMemo(
    () => appsNavigationItems.filter((item) => item.path !== '/spark/search' || hasEnabledLibraryTypes),
    [hasEnabledLibraryTypes],
  );

  return (
    <nav className={`navigation ${isExpanded ? 'expanded' : ''}`}>
      <div className="nav-logo">
        <div className="logo-icon">
          <LogoIcon />
        </div>
      </div>

      <button
        className="nav-expand-button"
        onClick={() => setIsExpanded(!isExpanded)}
        title={isExpanded ? "Collapse menu" : "Expand menu"}
      >
        {isExpanded ? <CollapseIcon /> : <ExpandIcon />}
      </button>
      {/*
      <div className="nav-section">
        <div className="logo-text">Menu</div>
        {visibleMainNavigationItems.map(item => (
          <Link
            key={item.path}
            to={item.path}
            className={`nav-item ${location.pathname === item.path ? 'active' : ''}`}
            title={item.label}
          >
            <div className="nav-icon">{item.icon}</div>
            <span className="nav-label">{item.label}</span>
          </Link>
        ))}
      </div>
      */}
      {/* <div className="nav-section apps">
        <div className="section-label">Apps</div>
        {appNavigationItems.map(item => (
          <Link
            key={item.path}
            to={item.path}
            className={`nav-item ${location.pathname === item.path ? 'active' : ''}`}
            title={item.label}
          >
            <div className="nav-icon">{item.icon}</div>
            <span className="nav-label">{item.label}</span>
          </Link>
        ))}
      </div> */}

      <div className="nav-section">
        {(() => {
          const item = radarNavigationItem;
          const isActive =
            location.pathname === '/radar' ||
            location.pathname === '/updates' ||
            (location.pathname.startsWith('/viewer') && navContext?.hint === 'radar') ||
            (navContext?.section === 'agent' && navContext?.hint === 'radar');
          return (
            <Link
              key={item.path}
              to={item.path}
              state={{
                label: item.label,
                hint: item.hint,
                navContext: {
                  section: 'agent',
                  path: item.path,
                  hint: item.hint,
                  label: item.label
                }
              }}
              className={`nav-item ${isActive ? 'active' : ''}`}
              title={item.label}
            >
              <div className="nav-icon">{item.icon}</div>
              <span className="nav-label">{item.label}</span>
            </Link>
          );
        })()}

        {visibleAppNavigationItems.map(item => {
          const isSparkRoot = item.path === '/spark';
          const matchesRoute = isSparkRoot
            ? (location.pathname.startsWith('/spark') && !location.pathname.startsWith('/spark/search'))
            : (location.pathname === item.path);
          const matchesContext = navContext?.section === 'app' && navContext?.path === item.path;
          const matchesProfileContext = location.pathname.startsWith('/profile') && matchesContext;
          const isActive = matchesRoute || matchesContext || matchesProfileContext;
          const baseState: Record<string, any> = {
            label: item.label,
            hint: item.hint,
            navContext: {
              section: 'app',
              path: item.path,
              hint: item.hint,
              label: item.label
            }
          };
          return (
            <Link
              key={`${item.path}-${item.label}`}
              to={item.path}
              state={baseState}
              className={`nav-item ${isActive ? 'active' : ''}`}
              title={item.label}
            >
              <div className="nav-icon">{item.icon}</div>
              <span className="nav-label">{item.label}</span>
            </Link>
          );
        })}
      </div>

      <div className="nav-section auth">

        <>
          <div className="user-menu">
            <span className="user-info">
              {user?.name}
            </span>
            <button onClick={handleLogout} className="logout-button">
              Logout
            </button>
          </div>
        </>

      </div>
    </nav >
  );
};
